"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScuTranslation = exports.TranslationPipeline = exports.TranslationCombination = exports.TranslationPhoneme = exports.TranslationReplace = exports.TranslationMatch = exports.Translation = exports.TranslationType = void 0;
var cerealParse_1 = require("../cerealParse");
var agency_1 = require("./agency");
var TranslationType;
(function (TranslationType) {
    TranslationType["match"] = "match";
    TranslationType["replace"] = "replace";
    TranslationType["combination"] = "combination";
    TranslationType["phoneme"] = "phoneme";
})(TranslationType || (exports.TranslationType = TranslationType = {}));
var Translation = /** @class */ (function () {
    function Translation(id, type, keys, priority, description, contextMatch) {
        this.id = id;
        this.type = type;
        this.keys = keys;
        this.priority = priority;
        this.description = description;
        this.contextMatch = contextMatch;
    }
    Translation.prototype.equals = function (that) {
        return (this.id === that.id &&
            this.type === that.type &&
            this.keys.length === that.keys.length &&
            this.keys.every(function (k, idx) { return k == that.keys[idx]; }) &&
            this.priority === that.priority &&
            this.description === that.description &&
            that.contextMatch === that.contextMatch);
    };
    Translation.parse = function (o) {
        try {
            var type = cerealParse_1.ParseUtils.getEnum(o, "type", TranslationType);
            switch (type) {
                case TranslationType.match:
                    return TranslationMatch.parse(o);
                case TranslationType.replace:
                    return TranslationReplace.parse(o);
                case TranslationType.phoneme:
                    return TranslationPhoneme.parse(o);
                case TranslationType.combination:
                    return TranslationCombination.parse(o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid Translation: Unhandled type '".concat(TranslationType[type], "'"));
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Translation ".concat(e.message));
        }
    };
    return Translation;
}());
exports.Translation = Translation;
var TranslationMatch = /** @class */ (function (_super) {
    __extends(TranslationMatch, _super);
    function TranslationMatch(id, keys, priority, description, contextMatch, match, lock, regex) {
        var _this = _super.call(this, id, TranslationType.match, keys, priority, description, contextMatch) || this;
        _this.match = match;
        _this.lock = lock;
        _this.regex = regex;
        return _this;
    }
    TranslationMatch.prototype.toJson = function () {
        return {
            id: this.id,
            type: TranslationType[this.type],
            keys: this.keys,
            priority: this.priority,
            description: this.description,
            contextMatch: this.contextMatch,
            match: this.match,
            lock: this.lock,
            regex: this.regex,
        };
    };
    TranslationMatch.prototype.equals = function (that) {
        if (!_super.prototype.equals.call(this, that))
            return false;
        // Above line asserts TranslationTypes are equal
        var newThat = that;
        return this.match === newThat.match && this.lock === newThat.lock && this.regex === newThat.regex;
    };
    TranslationMatch.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TranslationMatch(cerealParse_1.ParseUtils.getString(o, "id"), cerealParse_1.ParseUtils.getArray(o, "keys"), cerealParse_1.ParseUtils.getNumberOrNull(o, "priority"), cerealParse_1.ParseUtils.getStringOrNull(o, "description"), cerealParse_1.ParseUtils.getStringOrNull(o, "contextMatch"), cerealParse_1.ParseUtils.getString(o, "match"), cerealParse_1.ParseUtils.getBoolean(o, "lock"), cerealParse_1.ParseUtils.getBoolean(o, "regex")));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TranslationMatch: ".concat(e.message));
        }
    };
    return TranslationMatch;
}(Translation));
exports.TranslationMatch = TranslationMatch;
var TranslationReplace = /** @class */ (function (_super) {
    __extends(TranslationReplace, _super);
    function TranslationReplace(id, keys, priority, description, contextMatch, match, replace, lock, regex) {
        var _this = _super.call(this, id, TranslationType.replace, keys, priority, description, contextMatch) || this;
        _this.match = match;
        _this.replace = replace;
        _this.lock = lock;
        _this.regex = regex;
        return _this;
    }
    TranslationReplace.prototype.toJson = function () {
        return {
            id: this.id,
            type: TranslationType[this.type],
            keys: this.keys,
            priority: this.priority,
            description: this.description,
            contextMatch: this.contextMatch,
            match: this.match,
            replace: this.replace,
            lock: this.lock,
            regex: this.regex,
        };
    };
    TranslationReplace.prototype.equals = function (that) {
        if (!_super.prototype.equals.call(this, that))
            return false;
        // Above line asserts TranslationTypes are equal
        var newThat = that;
        return this.match === newThat.match && this.replace === newThat.replace && this.lock === newThat.lock && this.regex === newThat.regex;
    };
    TranslationReplace.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TranslationReplace(cerealParse_1.ParseUtils.getString(o, "id"), cerealParse_1.ParseUtils.getArray(o, "keys"), cerealParse_1.ParseUtils.getNumberOrNull(o, "priority"), cerealParse_1.ParseUtils.getStringOrNull(o, "description"), cerealParse_1.ParseUtils.getStringOrNull(o, "contextMatch"), cerealParse_1.ParseUtils.getString(o, "match"), cerealParse_1.ParseUtils.getString(o, "replace"), cerealParse_1.ParseUtils.getBoolean(o, "lock"), cerealParse_1.ParseUtils.getBoolean(o, "regex")));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TranslationReplace: ".concat(e.message));
        }
    };
    return TranslationReplace;
}(Translation));
exports.TranslationReplace = TranslationReplace;
var TranslationPhoneme = /** @class */ (function (_super) {
    __extends(TranslationPhoneme, _super);
    function TranslationPhoneme(id, keys, priority, description, contextMatch, match, phoneme) {
        var _this = _super.call(this, id, TranslationType.phoneme, keys, priority, description, contextMatch) || this;
        _this.match = match;
        _this.phoneme = phoneme;
        return _this;
    }
    TranslationPhoneme.prototype.toJson = function () {
        return {
            id: this.id,
            type: TranslationType[this.type],
            keys: this.keys,
            priority: this.priority,
            description: this.description,
            contextMatch: this.contextMatch,
            match: this.match,
            phoneme: this.phoneme,
        };
    };
    TranslationPhoneme.prototype.equals = function (that) {
        if (!_super.prototype.equals.call(this, that))
            return false;
        // Above line asserts TranslationTypes are equal
        var newThat = that;
        return this.match === newThat.match && this.phoneme === newThat.phoneme;
    };
    TranslationPhoneme.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TranslationPhoneme(cerealParse_1.ParseUtils.getString(o, "id"), cerealParse_1.ParseUtils.getArray(o, "keys"), cerealParse_1.ParseUtils.getNumberOrNull(o, "priority"), cerealParse_1.ParseUtils.getStringOrNull(o, "description"), cerealParse_1.ParseUtils.getStringOrNull(o, "contextMatch"), cerealParse_1.ParseUtils.getString(o, "match"), cerealParse_1.ParseUtils.getString(o, "phoneme")));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TranslationPhoneme: ".concat(e.message));
        }
    };
    return TranslationPhoneme;
}(Translation));
exports.TranslationPhoneme = TranslationPhoneme;
var TranslationCombination = /** @class */ (function (_super) {
    __extends(TranslationCombination, _super);
    function TranslationCombination(id, keys, priority, description, contextMatch, translations) {
        var _this = _super.call(this, id, TranslationType.combination, keys, priority, description, contextMatch) || this;
        _this.translations = translations;
        return _this;
    }
    TranslationCombination.prototype.toJson = function () {
        return {
            id: this.id,
            type: TranslationType[this.type],
            keys: this.keys,
            priority: this.priority,
            description: this.description,
            contextMatch: this.contextMatch,
            translations: this.translations.map(function (t) { return t.toJson(); }),
        };
    };
    TranslationCombination.prototype.equals = function (that) {
        if (!_super.prototype.equals.call(this, that))
            return false;
        var newThat = that;
        return this.translations.every(function (t, idx) { return t.equals(newThat.translations[idx]); });
    };
    TranslationCombination.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TranslationCombination(cerealParse_1.ParseUtils.getString(o, "id"), cerealParse_1.ParseUtils.getArray(o, "keys"), cerealParse_1.ParseUtils.getNumberOrNull(o, "priority"), cerealParse_1.ParseUtils.getStringOrNull(o, "description"), cerealParse_1.ParseUtils.getStringOrNull(o, "contextMatch"), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, "translations", Translation.parse, "throw")));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TranslationCombination: ".concat(e.message));
        }
    };
    return TranslationCombination;
}(Translation));
exports.TranslationCombination = TranslationCombination;
var TranslationPipeline = /** @class */ (function () {
    function TranslationPipeline(cleanupStage, functionalStage, constantStage, phonemeStage) {
        this.cleanupStage = cleanupStage;
        this.functionalStage = functionalStage;
        this.constantStage = constantStage;
        this.phonemeStage = phonemeStage;
    }
    TranslationPipeline.prototype.toJson = function () {
        return {
            cleanupStage: this.cleanupStage.map(function (c) { return c.toJson(); }),
            functionalStage: this.functionalStage.map(function (f) { return f.toJson(); }),
            constantStage: this.constantStage.map(function (c) { return c.toJson(); }),
            phonemeStage: this.phonemeStage.map(function (c) { return c.toJson(); }),
        };
    };
    TranslationPipeline.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TranslationPipeline(cerealParse_1.ParseUtils.getArrayOfSubobjects(o, "cleanupStage", Translation.parse, "throw"), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, "functionalStage", Translation.parse, "throw"), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, "constantStage", Translation.parse, "throw"), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, "phonemeStage", Translation.parse, "throw")));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TranslationPipeline: ".concat(e.message));
        }
    };
    return TranslationPipeline;
}());
exports.TranslationPipeline = TranslationPipeline;
var ScuTranslation = /** @class */ (function () {
    function ScuTranslation(id, name, agency, agenciesUsing, pipeline) {
        this.id = id;
        this.name = name;
        this.agency = agency;
        this.agenciesUsing = agenciesUsing;
        this.pipeline = pipeline;
    }
    ScuTranslation.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ScuTranslation(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getSubobject(o, 'agency', agency_1.MinimalAgency.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'agenciesUsing', agency_1.MinimalAgency.parse, 'throw'), cerealParse_1.ParseUtils.getSubobject(o, 'pipeline', TranslationPipeline.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ScuTranslation: ".concat(e.message));
        }
    };
    return ScuTranslation;
}());
exports.ScuTranslation = ScuTranslation;
//# sourceMappingURL=scuTranslations.js.map